module.exports = __webpack_public_path__ + "static/img/ross_noble_ani_extended_size_00012-fs8.73b4b09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/animation/ross_noble_ani_extended_size_00012-fs8.png
// module id = 165
// module chunks = 0